<section class="fixed inset-0 z-50 w-full h-20 bg-sigma-bar xl:bg-contain">
    <!-- Menu normal -->
    <div class="z-50 flex items-center justify-center w-full h-20 px-4 shadow-md bg-sigma-bar md:relative">
        <nav *ngFor="let item of data; let i = index" class="flex items-center justify-between w-full ">
            <div class="mt-1">
                <a class="text-3xl font-semibold leading-none" href="/home">
                    <picture>
                        <source class="h-14 sm:h-14 lg:h-14" type="image/webp" [attr.defaultImage]="brand.logoBase +'.webp'"
                            [attr.lazyLoad]="brand.logoBase +'.webp'" />
                        <img class="h-14 sm:h-14 lg:h-14" [defaultImage]="brand.logoBase +'.png'"
                            [lazyLoad]="brand.logoBase +'.png'" />
                    </picture>
                </a>
            </div>
            <div class="md:hidden">
                <button (click)="toggleMenuMobile()"
                    class="flex items-center px-3 py-2 text-gray-800 border-2 border-gray-600 rounded outline-none cursor-pointer navbar-burger hover:bg-gray-200 hover:text-gray-900">
                    <svg class="w-4 h-5 fill-current" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <title>Mobile menu</title>
                        <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
                    </svg>
                </button>
            </div>
            <ul
                class="justify-end flex-1 hidden h-8 text-xl text-gray-800 md:text-xl lg:text-2xl xl:text-2xl md:flex md:items-center md:w-auto md:space-x-2 lg:space-x-3 xl:space-x-4">
                <li *ngFor="let itemOpt of item.options; let i = index" class="relative menuHorizontal">
                    <!-- opciones nivel 1 normales-->
                    <a *ngIf="itemOpt.url !== '' && itemOpt.description === '' && itemOpt.fragment === ''" [routerLink]="itemOpt.url"
                        (click)="changeStatusWeb(item.options, i, itemOpt.id, 1,item.fragment)"
                        class="h-full px-2 py-2 capitalize transition duration-300 cursor-pointer menuLevel hover:bg-sigma-300 hover:text-white"
                        [ngClass]="itemOpt.active || urlActiveLevel1 === itemOpt.url ? 'bg-sigma-300 text-white': 'bg-sigma-bar text-gray-800'">{{itemOpt.title}}
                    </a>

                    <!-- contacts -->
                    <a *ngIf="itemOpt.url !== '' && itemOpt.description === '' && itemOpt.fragment !== ''  " [routerLink]="itemOpt.url"
                        (click)="changeStatusWeb(item.options, i, itemOpt.id, 1,item.fragment)" [fragment]="itemOpt.fragment"
                        class="h-full px-2 py-2 capitalize transition duration-300 cursor-pointer menuLevel hover:bg-sigma-300 hover:text-white"
                        [ngClass]="itemOpt.active ? 'bg-sigma-300 text-white': 'bg-sigma-bar text-gray-800'">{{itemOpt.title}}
                    </a>

                    <!-- Opciones con submenu con fragment - Nosotros-->
                    <a *ngIf="itemOpt.url === '' && itemOpt.description !== '' && itemOpt.fragment === '' "
                        class="h-full px-2 py-2 capitalize transition duration-300 cursor-default menuLevel hover:border-b-2 hover:bg-sigma-300 hover:text-white"
                        [ngClass]="itemOpt.active || urlActiveLevel1 === itemOpt.description ? 'bg-sigma-300 text-white': 'bg-sigma-bar text-gray-800'">{{itemOpt.title}}
                    </a>

                    <!-- Opciones con submenu normal - Productos-->
                    <a *ngIf="itemOpt.url === '' && itemOpt.description === '' "
                        (click)="changeStatusWeb(item.options, i, itemOpt.id, 1, itemOpt.fragment)"
                        class="h-full px-2 py-2 capitalize transition duration-300 cursor-default menuLevel hover:border-b-2 hover:bg-sigma-300 hover:text-white"
                        [ngClass]="itemOpt.active || urlActiveLevel1 === itemOpt.title  ? 'bg-sigma-300 text-white': 'bg-sigma-bar text-gray-800'">{{itemOpt.title}}
                    </a>

                    <!-- Submenu -->
                    <ul *ngIf="itemOpt.nodes.length > 0"
                        class="absolute z-10 flex-col hidden px-4 pt-6 pb-5 mt-2 menuHorizontal-hover:block bg-sigma-100">
                        <li *ngFor="let itemOptNodes of itemOpt.nodes" class="w-full">

                            <!-- Opciones del Submenu con fragment -->
                            <a *ngIf="itemOptNodes.type !== 'prod_detail_link'"
                                (click)="changeStatusWeb(item.options, i, itemOptNodes.id, 2, itemOpt.fragment)"
                                [routerLink]="itemOptNodes.url" [fragment]="itemOptNodes.fragment"
                                class="flex items-start p-3 hover:bg-sigma-200 menuSub"
                                [ngClass]="itemOptNodes.active || urlActiveLevel2 === itemOptNodes.fragment  ? 'bg-sigma-300': 'bg-sigma-100'">
                                <div class="ml-0">
                                    <p class="text-xl font-medium text-white">
                                        {{itemOptNodes.title}}
                                    </p>
                                </div>
                            </a>

                            <!-- Opciones del Submenu normales -->
                            <a *ngIf="itemOptNodes.type === 'prod_detail_link'"
                                (click)="changeStatusWeb(item.options, i, itemOptNodes.id, 2, itemOpt.fragment)"
                                [routerLink]="itemOptNodes.url" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}"
                                class="flex items-start p-3 hover:bg-sigma-200 menuSub">
                                <div class="ml-0">
                                    <p class="text-xl font-medium text-white">
                                        {{itemOptNodes.title}}
                                    </p>
                                </div>
                            </a>

                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
    </div>

    <!-- MENU MOBILE -->
    <div class="z-20 flex flex-col justify-between md:hidden cont-sidebar"
        [ngClass]="openMenuMobile ?'fixed inset-0' : 'block'">

        <div class="inset-0 overflow-hidden " [ngClass]="openMenuMobile? 'inset-0 absolute': 'block'">
            <!-- OVerlay -->
            <div class="inset-0 bg-gray-900 bg-opacity-75 " (click)="toggleMenuMobile()"
                [ngClass]="openMenuMobile?'absolute': 'flex'">
            </div>

            <!-- Menu -->
            <section class="transition duration-300 transform "
                [ngClass]="openMenuMobile ? 'absolute flex inset-y-0 left-0 translate-x-0 ease-out': 'fixed flex inset-y-0 left-0 -translate-x-full ease-in'">
                <div class="relative w-96">
                    <div *ngFor="let item of data; let i = index"
                        class="flex flex-col h-full px-6 py-6 overflow-y-auto bg-white">
                        <header class="w-full">
                            <div class="flex justify-between w-full font-sans text-lg font-normal text-white">
                                <div class="flex items-center w-full py-2">
                                    <a class="mr-auto text-3xl font-semibold leading-none" href="/home">
                                        <picture>
                                            <source class="h-16 -mt-1" type="image/webp"
                                                [attr.defaultImage]="brand.logoBase +'.webp'"
                                                [attr.lazyLoad]="brand.logoBase +'.webp'" />
                                            <img class="h-16 -mt-1" [defaultImage]="brand.logoBase +'.png'"
                                                [lazyLoad]="brand.logoBase +'.png'" />
                                        </picture>
                                    </a>
                                </div>
                                <div class="mt-4 md:hidden">
                                    <button (click)="toggleMenuMobile()"
                                        class="flex items-center px-1 py-1 border-2 rounded outline-none cursor-pointer border-sigma-300 text-sigma-300 navbar-burger hover:text-white hover:bg-sigma-300">
                                        <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none"
                                            viewbox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M6 18L18 6M6 6l12 12">
                                            </path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </header>
                        <br>
                        <div class="relative flex-1">
                            <div class="absolute inset-0 flex flex-col justify-between bg-white sm:flex cont-sidebar">
                                <!-- Menu de opciones -->
                                <div class="h-full border-gray-200">

                                    <div *ngFor="let itemOpt of item.options; let i = index">

                                        <!-- opciones nivel 1 normales-->
                                        <div *ngIf="itemOpt.nodes.length === 0 && itemOpt.url !== '' && itemOpt.description === '' && itemOpt.fragment === ''"
                                            (click)="changeStatusMobile(item.options, i, itemOpt.id); toggleMenuMobile()"
                                            [routerLink]="itemOpt.url"
                                            class="flex flex-col items-start justify-start w-full px-0 py-0 mx-0 overflow-hidden cursor-pointer focus:outline-none"
                                            [ngClass]="itemOpt.active || urlActiveLevel1 === itemOpt.url  ?'text-white mb-2 ':'mb-2 '">
                                            <div class="w-full px-5 py-3 font-semibold capitalize border-2 "
                                                [ngClass]="itemOpt.active || urlActiveLevel1 === itemOpt.url ?'bg-sigma-300 border-sigma-300 hover:bg-sigma-100 text-2xl text-white':'border-gray-300 bg-gray-100 hover:bg-gray-200 text-2xl hover:text-gray-600 text-gray-500'">
                                                {{itemOpt.title}}
                                            </div>
                                        </div>
                                        <!-- contacts -->
                                        <div *ngIf="itemOpt.nodes.length === 0 && itemOpt.url !== '' && itemOpt.description === '' && itemOpt.fragment !== '' "
                                            (click)="changeStatusMobile(item.options, i, itemOpt.id); toggleMenuMobile()" [fragment]="itemOpt.fragment"
                                            [routerLink]="itemOpt.url"
                                            class="flex flex-col items-start justify-start w-full px-0 py-0 mx-0 overflow-hidden cursor-pointer focus:outline-none"
                                            [ngClass]="itemOpt.active || urlActiveLevel1 === itemOpt.url  ?'text-white mb-2 ':'mb-2 '">
                                            <div class="w-full px-5 py-3 font-semibold capitalize border-2 "
                                                [ngClass]="itemOpt.active ?'bg-sigma-300 border-sigma-300 hover:bg-sigma-100 text-2xl text-white':'border-gray-300 bg-gray-100 hover:bg-gray-200 text-2xl hover:text-gray-600 text-gray-500'">
                                                {{itemOpt.title}}
                                            </div>
                                        </div>

                                        <!-- OPciones con Submenu -->
                                        <div *ngIf="itemOpt.nodes.length > 0"
                                            (click)="changeStatusMobile(item.options, i, itemOpt.id)"
                                            class="flex flex-col items-start justify-start w-full px-0 py-0 mx-0 overflow-hidden cursor-pointer focus:outline-none"
                                            [ngClass]="itemOpt.active ?'mb-5 ':'mb-2'">

                                            <!-- Opciones con submenu - Nosotros-->
                                            <div *ngIf="itemOpt.url === '' && itemOpt.description !== '' && itemOpt.fragment === ''  "
                                                class="w-full px-5 py-3 font-semibold capitalize menuItem "
                                                [ngClass]="itemOpt.active || urlActiveLevel1 === itemOpt.description ?'bg-sigma-300 border-sigma-300 hover:bg-sigma-100 text-2xl text-white':'border-gray-300 bg-gray-100 hover:bg-gray-200 text-2xl hover:text-gray-600 text-gray-500 border-2'">
                                                {{itemOpt.title}}
                                            </div>

                                            <div *ngIf="itemOpt.url === '' && itemOpt.description === '' "
                                                class="w-full px-5 py-3 font-semibold capitalize menuItem "
                                                [ngClass]="itemOpt.active || urlActiveLevel1 === itemOpt.title ?' bg-sigma-300 border-sigma-300 hover:bg-sigma-100 text-2xl text-white':'border-gray-300 bg-gray-100 hover:bg-gray-200 text-2xl hover:text-gray-600 text-gray-500 border-2 '">
                                                {{itemOpt.title}}
                                            </div>

                                            <!-- PAnel del Submenu -->
                                            <div *ngIf="itemOpt.nodes.length > 0 "
                                                class="w-full text-2xl font-semibold text-justify bg-gray-200 cursor-pointer menuPanel"
                                                [ngClass]="itemOpt.active ? 'active border-t-0 border-l-2 border-r-2 border-b-2 border-gray-300':'inactive'">

                                                <div *ngFor="let itemOptNodes of itemOpt.nodes; let j = index"
                                                    class="px-2 py-1">

                                                    <div *ngIf="itemOptNodes.type !== 'prod_detail_link'"
                                                        (click)="toggleMenuMobile()" [routerLink]="itemOptNodes.url"
                                                        [fragment]="itemOptNodes.fragment"
                                                        class="w-full px-3 py-3 text-gray-500 capitalize border-2 rounded-lg hover:bg-gray-300 focus:outline-none"
                                                        [ngClass]=" itemOptNodes.active || urlActiveLevel2 === itemOptNodes.fragment ?'
                                                        text-xl  bg-gray-300':'bg-gray-200 text-xl'">
                                                        {{itemOptNodes.title}}
                                                    </div>

                                                    <div *ngIf="itemOptNodes.type === 'prod_detail_link'"
                                                        (click)="toggleMenuMobile()" [routerLink]="itemOptNodes.url"
                                                        class="w-full px-3 py-3 text-xl text-gray-500 capitalize border-2 rounded-lg hover:bg-gray-300 focus:outline-none menuSubMenu"
                                                        [routerLink]="itemOptNodes.url" routerLinkActive="active"
                                                        [routerLinkActiveOptions]="{exact: true}">
                                                        {{itemOptNodes.title}}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    </div>

</section>